<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import { mapGetters } from 'vuex'
export default {
  onLaunch: function () {
    console.log('App Launch')

    uni.$on('user:login_success', () => {
      this.onLoginSuccess()
    })
    if (this.isLogin) {
      this.onLoginSuccess()
    }

    this.onInvalidToken()

  },
  onShow: function () {
    console.log('App Show')
    //小程序更新
    // #ifdef MP
    this.onUpdateApp()
    // #endif
  },
  onHide: function () {
    console.log('App Hide')
  },
  computed: {
    ...mapGetters(['isLogin', 'orgMenus'])
  },
  methods: {
    onInvalidToken() {
      uni.$once('user:invalid_token', (e) => {
        this.$store.dispatch('Logout').then(() => {
          const query = { redirect: this.$Route.fullPath }
          const loginPath = '/pages/login/login'
          if (loginPath == this.$Route.path) return

          this.$Router.push({ path: loginPath, query })
          //重新绑定
          this.onInvalidToken()
        })
      })
    },
    onLoginSuccess() {
    },
    onUpdateApp() {
      if (wx.canIUse('getUpdateManager')) {
        const updateManager = wx.getUpdateManager()
        updateManager.onCheckForUpdate((res) => {
          if (res.hasUpdate) {
            updateManager.onUpdateReady(function () {
              wx.showModal({
                title: '更新提示',
                content: '新版本已经准备好，是否重启应用？',
                success: function (res) {
                  console.log('success====', res)
                  // res: {errMsg: "showModal: ok", cancel: false, confirm: true}
                  if (res.confirm) {
                    // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
                    updateManager.applyUpdate()
                  }
                }
              })
            })
            updateManager.onUpdateFailed(function () {
              // 新的版本下载失败
              wx.showModal({
                title: '已经有新版本了哟~',
                content: '新版本已经上线啦~，请您删除当前小程序，重新搜索打开哟~'
              })
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
/*每个页面公共css */
@import 'uview-ui/index.scss';
@import '@/styles/index.scss';
</style>